import { render, staticRenderFns } from "./StudyDetailsTable.vue?vue&type=template&id=15b6dcb5"
import script from "./StudyDetailsTable.vue?vue&type=script&lang=js"
export * from "./StudyDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports